import { sum } from 'lib/array/arrayUtils'

function getInsuranceCoverAmountFromOrder(order: App.Order) {
  const deposit = order.depositDetails
  const balance = (deposit && !deposit.balance_paid_date) ? deposit.balance_amount : 0
  const paidTotal = sum(order.payments, payment => payment.amount)
  const serviceFee = order.serviceFee?.total || 0

  // If there's a deposit with outstanding balance, use payment-based calculation
  // Otherwise (fully paid orders), use order total
  const coverAmount = (deposit && balance > 0)
    ? paidTotal + balance - serviceFee
    : order.total - serviceFee

  return coverAmount
}

export default getInsuranceCoverAmountFromOrder
